<div class="container mx-auto h-100 mb-5">
  <!-- Page Header -->
  <div class="row mb-3 pt-3">
    <div class="col-12 d-flex flex-column justify-content-between align-items-start">
      <app-cms-page-content pageId="recommendations_page_header" [showNotFound]="false"></app-cms-page-content>
    </div>
  </div>

  <!-- Recommendation Type Tabs -->
  <div class="row mb-3">
    <div class="col-lg-4 col-md-5 col-12">
      <ul ngbNav [activeId]="activeTab" class="nav-tabs recommendation-nav gap-2 flex-nowrap">
        <li [ngbNavItem]="'TOP'" class="recommendation-tab recommendation-tab--top">
          <div class="tab-wrapper">
            <button  (click)="selectTab('TOP')" class="btn p-1 w-100 d-flex align-items-center gap-2" [class.tab-active]="activeTab === 'TOP'" [ngClass]="{'btn-default': activeTab !== 'TOP', 'btn-outline-primary': activeTab === 'TOP'}"><span class="tab-icon-circle " ><i class="material-icons">stars</i></span><span>{{ "TOP_PRODUCTS" | translate }}</span></button>
          </div>
        </li>
        <li [ngbNavItem]="'RECOMMENDED'" class="recommendation-tab recommendation-tab--recommended">
          <div class="tab-wrapper">
            <button  (click)="selectTab('RECOMMENDED')" class="btn p-1 w-100 d-flex align-items-center gap-2" [class.tab-active]="activeTab === 'RECOMMENDED'" [ngClass]="{'btn-default': activeTab !== 'RECOMMENDED', 'btn-outline-primary': activeTab === 'RECOMMENDED'}"><span class="tab-icon-circle" ><img src="assets/images/recommended.svg" alt="" style="width:16px;height:16px"></span> <span>{{ "RECOMMENDED_PRODUCTS" | translate }}</span></button>     
          </div>
        </li>
        <li [ngbNavItem]="'POPULAR'" class="recommendation-tab recommendation-tab--popular">
          <div class="tab-wrapper">
             <button  (click)="selectTab('POPULAR')" class="btn p-1 w-100 d-flex align-items-center gap-2" [class.tab-active]="activeTab === 'POPULAR'" [ngClass]="{'btn-default': activeTab !== 'POPULAR', 'btn-outline-primary': activeTab === 'POPULAR'}"><span class="tab-icon-circle" ><img src="assets/images/popular.svg" alt="" style="width:16px;height:16px"></span> <span>{{ "POPULAR_PRODUCTS" | translate }}</span></button>
        
          </div>
        </li>
      </ul>
    </div>
  </div>

  <!-- Loading State -->
  @if (isLoading) {
    <div class="row">
      <div class="col-12 text-center py-5">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">{{ "LOADING" | translate }}...</span>
        </div>
        <p class="mt-3 text-muted">{{ "LOADING" | translate }}</p>
      </div>
    </div>
  }

  <!-- Error State -->
  @if (hasError && !isLoading) {
    <div class="row">
      <div class="col-12">
        <div class="alert alert-danger d-flex align-items-center" role="alert">
          <span class="material-icons me-2">error</span>
          <div class="flex-grow-1">
            {{ errorMessage }}
          </div>
          <button class="btn btn-outline-danger btn-sm" (click)="retry()">
            {{ "RETRY" | translate }}
          </button>
        </div>
      </div>
    </div>
  }

  <!-- No Recommendations State -->
  @if (!isLoading && !hasError && recommendedArticles.length === 0) {
    <div class="row">
      <div class="col-12">
        <div class="alert alert-info text-center py-5" role="alert">
          <span class="material-icons mb-3" style="font-size: 3rem;">info</span>
          <h4>{{ "NO_RECOMMENDATIONS_AVAILABLE" | translate }}</h4>
          <p class="mb-0">{{ "NO_RECOMMENDATIONS_MESSAGE" | translate }}</p>
        </div>
      </div>
    </div>
  }

  <!-- Split View: Recommendations List + Article Details -->
  @if (!isLoading && !hasError && recommendedArticles.length > 0) {
    <div class="row recommendations-container">
      <!-- Left Side: Recommendations List -->
      <div class="col-lg-4 col-md-5 recommendations-list-container">
        <div class="recommendations-list">
          <div class="mb-3 d-flex justify-content-between align-items-center">
            <h5 class="text-secondary mb-0">
              <strong>{{ recommendedArticles.length }}</strong> {{ "ARTICLES" | translate }}
            </h5>
            <!-- Basket Selector and Bulk Add Button -->
            @if (selectedArticlesCount > 0) {
              <div class="d-flex align-items-center gap-2">
                <app-select-basket
                  (basketChanged)="onBasketChange($event)"
                  [selectedBasketId]="basketId"
                ></app-select-basket>
                <button
                  class="btn btn-primary btn-sm"
                  (click)="addSelectedToBasket()"
                  [disabled]="adding"
                  >
                  @if (!adding) {
                    <span>
                      <i class="material-icons align-middle" style="font-size: 18px;">add_shopping_cart</i>
                      {{ "ADD_TO_BASKET" | translate }} ({{ selectedArticlesCount }})
                    </span>
                  }
                  @if (adding) {
                    <span>
                      <span class="spinner-border spinner-border-sm me-1"></span>
                      {{ "ADDING" | translate }}...
                    </span>
                  }
                </button>
              </div>
            }
          </div>
          <div class="list-group">
            @for (article of recommendedArticles; track article; let i = $index) {
              <div
                class="list-group-item recommendation-item"
                [class.active]="selectedArticle?.id === article.id"
                [class.selected]="article.selected"
                (click)="selectArticle(article)"
                >
                <div class="d-flex align-items-start">
                  <!-- Checkbox -->
                  <div class="form-check me-2 mt-1">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      [id]="'check-' + article.id"
                      [(ngModel)]="article.selected"
                      (change)="toggleArticleSelection(article)"
                      (click)="$event.stopPropagation()"
                      />
                  </div>
                  <!-- Article Info (clickable) -->
                  <div class="flex-grow-1" style="cursor: pointer;">
                    <div class="d-flex align-items-center">
                      <img
                        [src]="article.thumbs && article.thumbs.length ? article.thumbs[0] : 'assets/images/part.svg'"
                        [alt]="article.description"
                        class="recommendation-thumbnail me-3"
                        />
                      <div class="flex-grow-1">
                        <h6 class="mb-1" [innerHTML]="article.description"></h6>
                        <small>{{ article.single_article_code }}</small>
                        <div class="prices d-flex flex-column mt-2">
                          @if (article.retail_price) {
                            <app-retail-price
                              [price]="article.retail_price"
                              [showLabel]="true"
                              class="d-block fw-bold"
                            ></app-retail-price>
                          }
                          @if (article.net_price) {
                            <div>
                              <app-nett-price
                                [price]="article.net_price"
                                [showLabel]="true"
                                class="fw-bold"
                              ></app-nett-price>
                            </div>
                          }
                        </div>
                      </div>
                      <i class="material-icons text-primary">chevron_right</i>
                    </div>
                  </div>
                </div>
                <!-- Quantity Input (shown when checked) -->
                @if (article.previously_bought) {
                  <div class="d-flex justify-content-end mt-1">
                    <app-previously-bought-badge [inverted]="selectedArticle?.id === article.id"></app-previously-bought-badge>
                  </div>
                }
                <!-- Quantity Input (shown when checked) -->
                @if (article.selected) {
                  <div class="mt-2 ms-4" (click)="$event.stopPropagation()">
                    <div class="input-group input-group-sm" style="max-width: 150px;" >
                      <span class="input-group-text">{{ "QUANTITY" | translate }}</span>
                      <input
                        type="number"
                        class="form-control"
                        [(ngModel)]="article.quantity"
                        (ngModelChange)="onQuantityChange(article)"
                        [attr.min]="article.min_order_amount || 1"
                        [attr.aria-label]="'QUANTITY' | translate"
                        />
                    </div>
                  </div>
                }
              </div>
            }
          </div>
        </div>
      </div>
      <!-- Right Side: Article Details -->
      <div class="col-lg-8 col-md-7 article-details-container">
        @if (!searchVisible) {
          <app-article-details
            #articleDetails
            (showArticleDetails)="showArticleDetails($event, null)"
            [leaseRequest]="leaseRequest"
            [standAlone]="true"
            [showBreadCrumbs]="false"
            >
          </app-article-details>
        }
      </div>
    </div>
  }
</div>
